import api from './api';
import { API_ROUTES } from '@/lib/constants';
import { createCrudService } from './crud.factory';
import type { Invoice, ApiResponse } from '@/types/table';

export const invoiceService = {
  ...createCrudService<Invoice>(API_ROUTES.INVOICES),

  send: async (id: string): Promise<ApiResponse<Invoice>> => {
    const response = await api.post(`${API_ROUTES.INVOICES}/${id}/send`);
    return response.data;
  },

  cancel: async (id: string): Promise<ApiResponse<Invoice>> => {
    const response = await api.post(`${API_ROUTES.INVOICES}/${id}/cancel`);
    return response.data;
  },

  duplicate: async (id: string): Promise<ApiResponse<Invoice>> => {
    const response = await api.post(`${API_ROUTES.INVOICES}/${id}/duplicate`);
    return response.data;
  },

  markAsPaid: async (id: string, accountId: string): Promise<ApiResponse<Invoice>> => {
    const response = await api.post(`${API_ROUTES.INVOICES}/${id}/mark-paid`, { accountId });
    return response.data;
  },

  /** Render the form's unsaved state as a PDF. Pass the id when previewing an edit. */
  preview: async (data: Record<string, unknown>, id?: string): Promise<Blob> => {
    const response = await api.post(`${API_ROUTES.INVOICES}/preview`, data, { responseType: 'blob', params: id ? { id } : undefined });
    return response.data;
  },

  downloadPdf: async (id: string): Promise<Blob> => {
    const response = await api.get(`${API_ROUTES.INVOICES}/${id}/pdf`, { responseType: 'blob' });
    return response.data;
  },

  getNextNumber: async (): Promise<ApiResponse<{ invoiceNumber: string }>> => {
    const response = await api.get(`${API_ROUTES.INVOICES}/next-number`);
    return response.data;
  },
};
